
import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import{ axiosInstance } from "../useAxios/useAxios";

// const axiosInstance = axiosInstance;

export const getFolderStructureList_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.folderStructure ,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "loginresponsne response");
        return response
    } catch (error) {
        console.log(error, "loginresponsne error");
        return error;
    }
} 